import { render, staticRenderFns } from "./editMemberInfo.vue?vue&type=template&id=50042404&scoped=true&"
import script from "./editMemberInfo.vue?vue&type=script&lang=js&"
export * from "./editMemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./editMemberInfo.vue?vue&type=style&index=0&id=50042404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50042404",
  null
  
)

export default component.exports